import React, {useContext} from "react";

import UIPopupContext from "../../popups/UIPopup/UIPopupContext";
import {editPrompt} from "../aiApi";


const UiPopupAIContentPrompts = (props) => {

  const {type} = props;

  const {uiPopupContext, uiPopupDispatch} = useContext(UIPopupContext);
  const {promptsList} = uiPopupContext;

  if (!promptsList) {
    return null
  }

  const isActiveType = "isActive" + type;

  const activePrompt = promptsList.find(promptObject => promptObject[isActiveType]);

  if (!activePrompt) {
    return null
  }

  const onTextAreChange = (e) => {
    uiPopupDispatch({
      promptsList: promptsList.map(groupObject => {
        if (groupObject.id === activePrompt.id) {
         groupObject.promptBody = e.target.value;
        }
        return groupObject
      }),
    });
  }

  const onInputBlur = async () => {
    await editPrompt(activePrompt);
  }

  return (
    <textarea
      className="u-h-full u-w-full ui-input"
      value={activePrompt.promptBody} // ...force the input's value to match the state variable...
      onChange={onTextAreChange} // ... and update the state variable on any edits!
      onBlur={onInputBlur} // ... and update the state variable on any edits!
    ></textarea>
  )
};

export default UiPopupAIContentPrompts

